import React from 'react';

export default function Status(props) {
  return (
    <section className="profile-status">
      <section>
        <label>Active Since</label> <span>{props.createdAt}</span>
      </section>
      <section>
        <label>Clients</label> <span>{props.clientsNumber}</span>
      </section>
    </section>
  );
}
